export default "__VITE_ASSET__BS5wkxz___"